export const REDUCER_NAME = 'ConditionAdd'
export const FORM_NAME = 'ConditionAdd'
export const MODAL_NAME = 'ConditionAdd'

export const actions = {
  FETCH: 'ConditionAdd/FETCH',
  FETCH_SUCCESS: 'ConditionAdd/FETCH_SUCCESS',
  FETCH_FAILURE: 'ConditionAdd/FETCH_FAILURE',

  FETCH_RULES_SUCCESS: 'ConditionAdd/FETCH_RULES_SUCCESS',
  FETCH_RULES_FAILURE: 'ConditionAdd/FETCH_RULES_FAILURE',

  SUBMIT: 'ConditionAdd/SUBMIT',
  SUBMIT_FAIL: 'ConditionAdd/SUBMIT_FAIL',

  CLOSE: 'ConditionAdd/CLOSE',
}

export const neededDropdowns = [
  'Flat as InterestTypeID',
  'PenaltyType as PenaltyTypeID',
  'PenPrepayType as AdvFeeTypeID',
  'InsProductRateTypeID as InsRateTypeID',
]

export const minMaxRuls = [
  { min: 'InterestMin', max: 'InterestMax', nameInForm: 'InterestRate' },
  { min: 'PenPrincipalMin', max: 'PenPrincipalMax', nameInForm: 'PenaltyPriRate' },
  { min: 'PenInterestMin', max: 'PenInterestMax', nameInForm: 'PenaltyIntRate' },
  { min: 'PenPrepayMin', max: 'PenPrepayMax', nameInForm: 'AdvFeeRate' },
  { min: 'UCLCMin', max: 'UCLCMax', nameInForm: 'UCLCRate' },
  { min: 'InsProductRateMin', max: 'InsProductRateMax', nameInForm: 'InsRate' },
]

export const neededValidationRules = [
  'InterestCheck',
  'InterestMin',
  'InterestMax',

  'Flat_LKP',
  'FlatCheck',

  'PenPrincipalCheck',
  'PenPrincipalMin',
  'PenPrincipalMax',

  'PenInterestCheck',
  'PenInterestMin',
  'PenInterestMax',

  'PenaltyType_LKP',
  'PenaltyTypeCheck',

  'PenPrepayCheck',
  'PenPrepayMin',
  'PenPrepayMax',

  'PenPrepayType_LKP',
  'PenPrepayTypeCheck',

  'UCLCCheck',
  'UCLCMin',
  'UCLCMax',

  'InsProductCheck',
  'InsProductRateMin',
  'InsProductRateMax',

  'InsProductRateType_LKP',
]
